export const images_northern4 = [
  {
    original: "/contactus/officesImgs/northern4/_1.jpg",
    thumbnail: "/contactus/officesImgs/northern4/_1.jpg",
  },
  {
    original: "/contactus/officesImgs/northern4/_2.jpg",
    thumbnail: "/contactus/officesImgs/northern4/_2.jpg",
  },
  {
    original: "/contactus/officesImgs/northern4/_3.jpg",
    thumbnail: "/contactus/officesImgs/northern4/_3.jpg",
  },
  {
    original: "/contactus/officesImgs/northern4/_4.jpg",
    thumbnail: "/contactus/officesImgs/northern4/_4.jpg",
  },
  {
    original: "/contactus/officesImgs/northern4/_5.jpg",
    thumbnail: "/contactus/officesImgs/northern4/_5.jpg",
  },
  {
    original: "/contactus/officesImgs/northern4/_6.jpg",
    thumbnail: "/contactus/officesImgs/northern4/_6.jpg",
  },
  {
    original: "/contactus/officesImgs/northern4/_7.jpg",
    thumbnail: "/contactus/officesImgs/northern4/_7.jpg",
  },
  {
    original: "/contactus/officesImgs/northern4/_8.jpg",
    thumbnail: "/contactus/officesImgs/northern4/_8.jpg",
  },
  {
    original: "/contactus/officesImgs/northern4/_9.jpg",
    thumbnail: "/contactus/officesImgs/northern4/_9.jpg",
  },
];

export const images_nd64 = [
  {
    original: "/contactus/officesImgs/nd64/_1.jpg",
    thumbnail: "/contactus/officesImgs/nd64/_1.jpg",
  },
  {
    original: "/contactus/officesImgs/nd64/_2.jpg",
    thumbnail: "/contactus/officesImgs/nd64/_2.jpg",
  },
  {
    original: "/contactus/officesImgs/nd64/_3.jpg",
    thumbnail: "/contactus/officesImgs/nd64/_3.jpg",
  },
  {
    original: "/contactus/officesImgs/nd64/_4.jpg",
    thumbnail: "/contactus/officesImgs/nd64/_4.jpg",
  },
  {
    original: "/contactus/officesImgs/nd64/_5.jpg",
    thumbnail: "/contactus/officesImgs/nd64/_5.jpg",
  },
  {
    original: "/contactus/officesImgs/nd64/_6.jpg",
    thumbnail: "/contactus/officesImgs/nd64/_6.jpg",
  },
  {
    original: "/contactus/officesImgs/nd64/_7.jpg",
    thumbnail: "/contactus/officesImgs/nd64/_7.jpg",
  },
  {
    original: "/contactus/officesImgs/nd64/_8.jpg",
    thumbnail: "/contactus/officesImgs/nd64/_8.jpg",
  },
  {
    original: "/contactus/officesImgs/nd64/_9.jpg",
    thumbnail: "/contactus/officesImgs/nd64/_9.jpg",
  },
  {
    original: "/contactus/officesImgs/nd64/_10.jpg",
    thumbnail: "/contactus/officesImgs/nd64/_10.jpg",
  },
];

export const images_sedova8 = [
  {
    original: "/contactus/officesImgs/sedova8/_1.jpg",
    thumbnail: "/contactus/officesImgs/sedova8/_1.jpg",
  },
  {
    original: "/contactus/officesImgs/sedova8/_2.jpg",
    thumbnail: "/contactus/officesImgs/sedova8/_2.jpg",
  },
  {
    original: "/contactus/officesImgs/sedova8/_3.jpg",
    thumbnail: "/contactus/officesImgs/sedova8/_3.jpg",
  },
  {
    original: "/contactus/officesImgs/sedova8/_4.jpg",
    thumbnail: "/contactus/officesImgs/sedova8/_4.jpg",
  },
  {
    original: "/contactus/officesImgs/sedova8/_5.jpg",
    thumbnail: "/contactus/officesImgs/sedova8/_5.jpg",
  },
  {
    original: "/contactus/officesImgs/sedova8/_6.jpg",
    thumbnail: "/contactus/officesImgs/sedova8/_6.jpg",
  },
  {
    original: "/contactus/officesImgs/sedova8/_7.jpg",
    thumbnail: "/contactus/officesImgs/sedova8/_7.jpg",
  },
  {
    original: "/contactus/officesImgs/sedova8/_8.jpg",
    thumbnail: "/contactus/officesImgs/sedova8/_8.jpg",
  },
  {
    original: "/contactus/officesImgs/sedova8/_9.jpg",
    thumbnail: "/contactus/officesImgs/sedova8/_9.jpg",
  },
  {
    original: "/contactus/officesImgs/sedova8/_11.jpg",
    thumbnail: "/contactus/officesImgs/sedova8/_11.jpg",
  },
];

export const images_nezalezhnoi65 = [
  {
    original: "/contactus/officesImgs/nezalezhnoi65/_2.jpg",
    thumbnail: "/contactus/officesImgs/nezalezhnoi65/_2.jpg",
  },
  {
    original: "/contactus/officesImgs/nezalezhnoi65/_3.jpg",
    thumbnail: "/contactus/officesImgs/nezalezhnoi65/_3.jpg",
  },
  {
    original: "/contactus/officesImgs/nezalezhnoi65/_4.jpg",
    thumbnail: "/contactus/officesImgs/nezalezhnoi65/_4.jpg",
  },
  {
    original: "/contactus/officesImgs/nezalezhnoi65/_5.jpg",
    thumbnail: "/contactus/officesImgs/nezalezhnoi65/_5.jpg",
  },
  {
    original: "/contactus/officesImgs/nezalezhnoi65/_6.jpg",
    thumbnail: "/contactus/officesImgs/nezalezhnoi65/_6.jpg",
  },
  {
    original: "/contactus/officesImgs/nezalezhnoi65/_7.jpg",
    thumbnail: "/contactus/officesImgs/nezalezhnoi65/_7.jpg",
  },
  {
    original: "/contactus/officesImgs/nezalezhnoi65/_8.jpg",
    thumbnail: "/contactus/officesImgs/nezalezhnoi65/_8.jpg",
  },
  {
    original: "/contactus/officesImgs/nezalezhnoi65/_9.jpg",
    thumbnail: "/contactus/officesImgs/nezalezhnoi65/_9.jpg",
  },
  {
    original: "/contactus/officesImgs/nezalezhnoi65/_11.jpg",
    thumbnail: "/contactus/officesImgs/nezalezhnoi65/_11.jpg",
  },
  {
    original: "/contactus/officesImgs/nezalezhnoi65/_12.jpg",
    thumbnail: "/contactus/officesImgs/nezalezhnoi65/_12.jpg",
  },
  {
    original: "/contactus/officesImgs/nezalezhnoi65/_13.jpg",
    thumbnail: "/contactus/officesImgs/nezalezhnoi65/_13.jpg",
  },
];

